// utils/googleLoginUtils.ts

import { useGoogleLogin, TokenResponse } from '@react-oauth/google';
import { toast } from '@/components/global/Toast'
import loginApi from '@/service/modules/loginApi'
import { setCookie } from '@/utils/cookie'
import { useDispatch } from 'react-redux'
import { setUserInfo } from '@/store/slices/userSlice'
import { matomoSetCustomDimension } from "@/utils/matomoEvent"

interface GoogleLoginProps {
  onSuccessJump?: () => void;
}

export const useGoogleLoginUtils = ({ onSuccessJump }: GoogleLoginProps) => {
  const dispatch = useDispatch();

  const onGoogleLogin = useGoogleLogin({
    onSuccess: async (tokenResponse: TokenResponse) => {
      try {
        let res = await loginApi.googleLogin({ access_token: tokenResponse.access_token });
        if (res.data) {
          toast.show('Login Successful!');

          // matomo记录登录结果
          let LoginResult = 0
          if (window && (window as any)._paq) {
            (window as any)._paq.push(['setUserId', res.data.customerID]);
          }
          matomoSetCustomDimension(21, LoginResult)

          // 保存 userEmail
          if (res.data.email) {
            localStorage.setItem('userEmail', res.data.email || '');
            setCookie('userCustomerId', res.data.customerID || '');
          } else {
            localStorage.removeItem('userEmail');
          }

          // 登录成功，跳转
          if (onSuccessJump) {
            // 将用户信息存入Redux
            dispatch(setUserInfo(res.data))
            setTimeout(() => {
              onSuccessJump();
            }, 1500);
          }
        } else {
          toast.show('Google Login Failure');
        }
      } catch (error) {
        toast.show('Google Login Failure');
      }
    },
    onError: () => {
      console.error('Google Login Failure');
      toast.show('Google Login Failure');
    },
  });

  return onGoogleLogin;
};
